import { useLocation } from 'react-router-dom';
import { AddVenueSkeleton } from '@components/add-venue-skeleton/add-venue-skeleton';
import { ReportPageSkeleton } from '@components/report-skeleton/report-skeleton';
import { SelectVenueSkeleton } from '@components/select-venue-skeleton/select-venue-skeleton';

import { DefaultLayoutShell } from './components/default-layout-shell';
import { WithoutSidebarShell } from './components/without-sidebar-shell';
import type { AuthLoadingSkeletonProps } from './auth-loading-skeleton.type';
import { GenericContentSkeleton } from './generic-content-skeleton';

export const AuthLoadingSkeleton = ({ children }: AuthLoadingSkeletonProps) => {
  const { pathname } = useLocation();

  // Select venue — without-sidebar page; use the shell so the loading/redirect skeleton
  // keeps the same top offset as the real page (LayoutWithoutSidebar) and doesn't jump.
  if (pathname.startsWith('/select-venue')) {
    return <WithoutSidebarShell>{children ?? <SelectVenueSkeleton />}</WithoutSidebarShell>;
  }

  // Without sidebar routes
  if (pathname.endsWith('/report')) {
    return <WithoutSidebarShell>{children ?? <ReportPageSkeleton />}</WithoutSidebarShell>;
  }

  if (pathname.endsWith('/add-venue')) {
    return <WithoutSidebarShell>{children ?? <AddVenueSkeleton />}</WithoutSidebarShell>;
  }

  if (pathname.endsWith('/info-point')) {
    return <WithoutSidebarShell>{children ?? <GenericContentSkeleton />}</WithoutSidebarShell>;
  }

  // Default layout routes — no shell during auth phase to avoid skeleton→real shell jump.
  // LayoutDefault already renders its own skeleton shell while company/club data loads.
  if (children) {
    return <DefaultLayoutShell>{children}</DefaultLayoutShell>;
  }

  return <div className='bg-secondary h-[calc(100dvh)]' />;
};
